var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 9C30.87 9 31.575 9.3 32.13 9.885C32.7 10.5 33 11.175 33 12V28.5C33 29.325 32.7 30 32.13 30.615C31.575 31.2 30.87 31.5 30 31.5H6C5.13 31.5 4.425 31.2 3.87 30.615C3.3 30 3 29.325 3 28.5V12C3 11.175 3.3 10.5 3.87 9.885C4.425 9.3 5.13 9 6 9H12V6C12 5.13 12.3 4.425 12.87 3.87C13.425 3.3 14.13 3 15 3H21C21.87 3 22.575 3.3 23.13 3.87C23.7 4.425 24 5.13 24 6V9H30ZM6 12V28.5H30V12H6ZM21 9V6H15V9H21Z",
    fill: "#BB6BD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBc);
export default __webpack_public_path__ + "static/media/bc.19d9e672d9d600b4c7434a7e6642ce72.svg";
export { ForwardRef as ReactComponent };